import { render } from "./NavbarLogo.vue?vue&type=template&id=5eb2801a"
import script from "./NavbarLogo.vue?vue&type=script&lang=ts"
export * from "./NavbarLogo.vue?vue&type=script&lang=ts"
script.render = render

export default script